[<RequireQualifiedAccess>]
module ListPage

open Shared
open System
open Elmish
open Feliz
open API
open ViewTypes
open RenderHelpers

let lijstsongs (songlijst: Guid list) (allsongs: ShortSong list) =
    songlijst
    |> List.map (fun songgui ->
        allsongs
        |> List.tryFind (fun song -> song.ShortSongId = songgui))
    |> List.choose id // lijst kan nummers bevatten die verwijderd zijn.

[<AutoOpen>]
module private Helpers =
    let changePosition id (lijst: Lijst) posfun =
        let songlijst = lijst.SongLijst

        let condition =
            if (posfun 1 1) = 2 then songlijst.Length else 0

        let position =
            songlijst |> List.findIndex (fun g -> g = id)

        let newposition (index: int) =
            if position = condition then songlijst.[index]
            elif index = (posfun position 1) then songlijst.[position]
            elif index = position then songlijst.[posfun position 1]
            else songlijst.[index]

        songlijst
        |> List.mapi (fun i _ -> newposition i)
        |> fun songlijst' -> { lijst with SongLijst = songlijst' }

    let positionUp id lijst = changePosition id lijst (-)
    let positionDown id lijst = changePosition id lijst (+)


    let filtersongs filterstr (songs: ShortSong list) =
        let filter (filterstr: string) (name: string) =
            name
            |> fun s -> s.ToLower()
            |> fun s -> s.Contains(filterstr.ToLower())

        songs
        |> List.filter (fun song -> filter filterstr (Song.NameAndArtist song))

    let filteredAllSongsList (lijstState: LijstState) =
        lijstState.AllSongs
        |> filtersongs lijstState.Filterstr

    let makeLijstContentState (lijstState: LijstState) =

        match lijstState.SelectedLijst with
        | None ->
            { lijstState with
                  Filter = true
                  LijstSongs =
                      lijstState.AllSongs
                      |> filtersongs lijstState.Filterstr }
        | Some lijst ->
            { lijstState with
                  Filter = false
                  LijstSongs = lijstsongs lijst.SongLijst lijstState.AllSongs }

//let init (songs: ShortSong list) =
//    { SelectedLijst = None
//      WijzigLijst = false
//      Filter = false
//      Filterstr = ""
//      AllSongs = songs
//      LijstSongs = List.empty }

let update (lijstMsg: LijstMsg) (lijstState: LijstState) =
    match lijstMsg with
    | ViewTypes.LijstClicked lijst ->
        match lijstState.WijzigLijst with
        | true -> lijstState
        | false ->
            { lijstState with
                  SelectedLijst = lijst }
    | ViewTypes.WijzigLijstClicked ->
        match lijstState.SelectedLijst with
        | None -> { lijstState with WijzigLijst = false }
        | Some _ -> { lijstState with WijzigLijst = true }
    | ViewTypes.BewaarLijstClicked ->
        match lijstState.SelectedLijst with
        | None -> lijstState
        | Some _ -> { lijstState with WijzigLijst = false }
    | ViewTypes.CancelLijstEditClicked ->
        match lijstState.SelectedLijst with
        | None -> lijstState
        | Some _ -> { lijstState with WijzigLijst = false }
    | ViewTypes.RemoveLijstClicked ->
        { lijstState with
              SelectedLijst = None
              WijzigLijst = false }
    | ViewTypes.LijstNameChanged name ->
        lijstState.SelectedLijst
        |> Option.map (fun lijst -> { lijst with Name = name })
        |> fun sellijst ->
            { lijstState with
                  SelectedLijst = sellijst }
    | ViewTypes.PositionUp id ->
        { lijstState with
              SelectedLijst =
                  lijstState.SelectedLijst
                  |> Option.map (positionUp id) }

    | ViewTypes.PositionDown id ->
        { lijstState with
              SelectedLijst =
                  lijstState.SelectedLijst
                  |> Option.map (positionDown id) }
    | ViewTypes.NewSongClicked song -> lijstState
    | ViewTypes.FilterSongsChanged filter -> { lijstState with Filterstr = filter }
    | ViewTypes.FilterSongsTrash -> { lijstState with Filterstr = "" }
    | ViewTypes.UpdateAllSongs allsongs -> { lijstState with AllSongs = allsongs }
    | ViewTypes.SongClicked songid -> lijstState
    | ViewTypes.RemoveSongFromLijstClicked songid ->
        lijstState.SelectedLijst
        |> Option.map (fun lijst ->
            { lijst with
                  SongLijst =
                      lijst.SongLijst
                      |> List.filter (fun id -> id <> songid) })
        |> fun lijst ->
            { lijstState with
                  SelectedLijst = lijst }

    | ViewTypes.AddSongToLijstClicked songid ->
        lijstState.SelectedLijst
        |> Option.map (fun lijst ->
            { lijst with
                  SongLijst =
                   songid :: lijst.SongLijst
                   |>List.distinct })
        |> fun lijst ->
            { lijstState with
                  SelectedLijst = lijst }

module RItems =
    let btnElm (faclass: string) (dispatch: LijstMsg->unit) dispfun extraCls =
        Html.button [ prop.className ("button level-item" + " " + extraCls)
                      prop.onClick (fun _ -> dispatch dispfun)
                      prop.children [ Html.i [ prop.className faclass ] ] ]

    let navBar lijststate dispatch =


        let sumsongs =
            sprintf " (%A)" lijststate.AllSongs.Length

        let sumlist =
            sprintf " (%A)" lijststate.LijstSongs.Length

        let headtxt =
            match lijststate.SelectedLijst with
            | None -> "All Songs" + sumsongs
            | Some lijst -> lijst.Name + sumlist

        let levelLeft () =
            Html.strong [ prop.className "level-item"
                          prop.text headtxt ]
            |> wrap1In Html.div "level-left"
//(Song.create "unknown artist" "unknown title")
        let levelRight () =
            if lijststate.Filter then
                btnElm "fa fa-file" dispatch (NewSongClicked (Song.create "unknown artist" "unknown title")) "has-text-danger"
            else
                btnElm "fa fa-edit" dispatch ViewTypes.WijzigLijstClicked "has-text-danger"
            |>wrap1In Html.div "level-right"

        [ levelLeft (); levelRight () ]
        |> wrapxIn Html.div "level is-mobile"



    let filter (filterstr: string) (dispatch: LijstMsg -> unit) =
        let clearFilterBtn=
            btnElm "fa fa-times" dispatch (FilterSongsTrash) "is-medium"

        Html.div [ prop.classes [ "field"; "has-addons"; "" ]
                   prop.children [ Html.div [ prop.classes [ "control"
                                                             "is-expanded" ]
                                              prop.children [ Html.input [ prop.classes [ "input"; "is-medium" ]
                                                                           prop.placeholder "filter"
                                                                           prop.valueOrDefault filterstr
                                                                           prop.onChange
                                                                               (FilterSongsChanged >> dispatch) ] ] ]

                                   Html.div [
                                       prop.className "control"
                                       prop.children [
                                           clearFilterBtn
                                        ] ] ] ]

    let songItem (song: ShortSong) (isSelected: bool) (dispatch: LijstMsg -> unit)=
        let item() =
            Html.nav [
                prop.className "level is-mobile"
                prop.children [
                    Html.div [
                        prop.className "level-left"
                        prop.children [
                            Html.span [
                                prop.className "is-size-5 level-item"
                                prop.text song.Name]
                            Html.span [
                                prop.className "level-item"
                                prop.text (" - "+song.Artist) ]
                        ]
                    ]
                ]
            ]

        Html.a [ prop.onClick (fun _ -> dispatch (SongClicked song.ShortSongId))
                 prop.className (if isSelected then "is-active" else "")
                 prop.children [
                     item()
                     ] ]

    let songs (lijstState: LijstState) (dispatch: LijstMsg -> unit) =
        Html.div [ prop.className "menu-list"
                   prop.children [ for song in lijstState.LijstSongs do
                                       (songItem song false dispatch) ] ]

    let content lijststate (dispatch: LijstMsg -> unit)=
        Html.div [
                   navBar lijststate dispatch
                   if lijststate.Filter then filter lijststate.Filterstr dispatch
                   songs lijststate dispatch
                   Html.hr [] ]


module RItemsEdit =
    // songitem in all songs list
    let songItem (song: ShortSong) (isSelected: bool) (dispatch: LijstMsg -> unit)=
        Html.a [ prop.onClick (fun _ -> dispatch (AddSongToLijstClicked song.ShortSongId))
                 prop.className (if isSelected then "is-active" else "")
                 prop.children [
                     Html.span [ prop.text song.Name ]
                     Html.span [ prop.text (" - " + song.Artist) ]
                     ] ]

    let buttons (lijstState: LijstState) (dispatch: LijstMsg -> unit)=
        Html.div [ prop.className "field is-grouped is-grouped-centered"
                   prop.children [ Html.p [ prop.className "control"
                                            prop.children [ Html.a [ prop.className "button is-primary"
                                                                     prop.text "save"
                                                                     prop.onClick (fun _ ->
                                                                         dispatch (BewaarLijstClicked)) ] ] ]
                                   Html.p [ prop.className "control"
                                            prop.children [ Html.a [ prop.className "button is-warning"
                                                                     prop.text "cancel"
                                                                     prop.onClick (fun _ ->
                                                                         dispatch (CancelLijstEditClicked)) ] ] ]
                                   Html.p [ prop.className "control"
                                            prop.children [ Html.a [ prop.className "button is-danger"
                                                                     prop.text "delete"
                                                                     prop.onClick (fun _ ->
                                                                         dispatch (RemoveLijstClicked)) ] ] ] ] ]

    let editTitle (lijstState: LijstState) (dispatch: LijstMsg -> unit) =
        match lijstState.SelectedLijst with
        | None -> Html.none
        | Some lijst ->
            Html.div [ prop.className "field"
                       prop.children [ Html.div [ prop.className "control"
                                                  prop.children [ Html.label [ prop.className
                                                                                   "is-size-5 has-text-weight-semibold"
                                                                               prop.text "Name" ]
                                                                  Html.input [ prop.className "input"
                                                                               prop.type' "text"
                                                                               prop.defaultValue lijst.Name
                                                                               prop.onChange
                                                                                   (LijstNameChanged >> dispatch) ] ] ] ] ]

    let isSelectedSong songs song =
        songs
        |> List.exists (fun song' -> song'.ShortSongId = song.ShortSongId)

    // song item in listsongs
    let listsongItem (song: ShortSong) counter dispatch =
        let bgc =
            if counter % 2 = 0 then "has-background-white" else "has-background-white-bis"

        let mobileShortSong =
            song.Name
            |> fun s -> s.Split '-'
            |> fun s -> s.[s.Length - 1]
            |> fun s -> s.Trim()
            |> fun s -> if s.Length > 25 then (s.Substring(0, 24) + " ...") else s


        let navbar =
            Html.nav [ prop.className ("level is-mobile" + " " + bgc)
                       prop.title song.Name
                       prop.children [ Html.div [ prop.className "level-left"
                                                  prop.children [ Html.div [ prop.className "level-item"
                                                                             prop.children [ Html.a [ prop.className
                                                                                                          "is-hidden-tablet" // shortsong is dus op mobiel
                                                                                                      prop.text
                                                                                                          mobileShortSong ]
                                                                                             Html.a [ prop.className
                                                                                                          "is-hidden-mobile" // alles anders dan mobiel is gewon naam
                                                                                                      prop.text
                                                                                                          song.Name ] ] ] ] ]
                                       Html.div [ prop.className "level-right"
                                                  prop.children [ Html.a [ prop.className "level-item"
                                                                           prop.children [ Html.i [ prop.className
                                                                                                        "fas fa-arrow-up"
                                                                                                    prop.onClick (fun _ ->
                                                                                                        dispatch
                                                                                                            (PositionUp
                                                                                                                song.ShortSongId)) ] ] ]
                                                                  Html.a [ prop.className "level-item"
                                                                           prop.children [ Html.i [ prop.className
                                                                                                        "fas fa-arrow-down"
                                                                                                    prop.onClick (fun _ ->
                                                                                                        dispatch
                                                                                                            (PositionDown
                                                                                                                song.ShortSongId)) ] ] ]
                                                                  Html.a [ prop.className "level-item"
                                                                           prop.children [ Html.i [ prop.className
                                                                                                        "fas fa-times"
                                                                                                    prop.onClick (fun _ ->
                                                                                                        dispatch
                                                                                                            (RemoveSongFromLijstClicked
                                                                                                                song.ShortSongId)) ] ] ] ] ]


                                        ] ]

        Html.div [ navbar ]

    let listSongs (lijstState: LijstState) (dispatch: LijstMsg -> unit) =
        let sumlist =
            sprintf " (%A)" lijstState.LijstSongs.Length

        let mutable counter = 0
        Html.div [ prop.className "menu-list"
                   prop.children [ Html.label [ prop.className "is-size-5 has-text-weight-semibold"
                                                prop.text ("Songs in list" + sumlist) ]
                                   for song in lijstState.LijstSongs do
                                       counter <- counter + 1
                                       (listsongItem song counter dispatch) ] ]

    let filter (filterstr: string) dispatch =
        Html.div [ prop.classes [ "field"; "has-addons" ]
                   prop.children [ Html.div [ prop.classes [ "control"
                                                             "is-expanded" ]
                                              prop.children [ Html.input [ prop.classes [ "input"; "is-medium" ]
                                                                           prop.placeholder "filter"
                                                                           prop.valueOrDefault filterstr
                                                                           prop.onChange
                                                                               (FilterSongsChanged >> dispatch) ] ] ]

                                   Html.div [ prop.className "control"
                                              prop.children [ Html.button [ prop.classes [ "button"; "is-medium" ]
                                                                            prop.onClick (fun _ ->
                                                                                dispatch FilterSongsTrash)
                                                                            prop.children [ Html.i [ prop.classes [ "fa"
                                                                                                                    "fa-times" ] ] ] ] ] ] ] ]

    let allSongs (lijstState: LijstState) (dispatch: LijstMsg -> unit) =

        Html.div [ prop.className "menu-list"
                   prop.children [ Html.label [ prop.className "is-size-5 has-text-weight-semibold"
                                                prop.text "All Songs" ]
                                   filter lijstState.Filterstr dispatch
                                   //let f = (filteredAllSongsList lijstState)
                                   for song in (filteredAllSongsList lijstState) do
                                       (songItem song (isSelectedSong lijstState.LijstSongs song) dispatch) ] ]

    let content (lijststate: LijstState) (dispatch: LijstMsg -> unit) =
        Html.div [ buttons lijststate dispatch
                   editTitle lijststate dispatch
                   listSongs lijststate dispatch
                   Html.hr []
                   allSongs lijststate dispatch ]

let render (state: LijstState) (dispatch: LijstMsg -> unit) =
    let lijststate = Helpers.makeLijstContentState state
    if state.WijzigLijst then RItemsEdit.content lijststate dispatch else RItems.content lijststate dispatch
